import AcaoFluxo from '../produto/shared-components/AcaoFluxo';

export default AcaoFluxo;
